import "./CcIntroduce.css";
import ActingLogo from "../../../../assets/img/Empty.png";
import EmergencyLogo from "../../../../assets/img/black_profile_c.png";
import Kakao from "../../../../assets/img/Talk.svg";
import Insta from "../../../../assets/img/Insta.svg";
import MapPin from "../../../../assets/img/location.png";

export default function CcIntroduce({ data, council }) {
  const displayData = {
    type: data?.type || "STUDENT_COUNCIL",
    name: data?.name || council?.name || "",
    slogan: data?.slogan || "",
    profileImg: data?.profileImg || council?.logoUrl || "",
    officeLocation: data?.officeLocation || "",
    kakaoUrl: data?.kakaoUrl || "",
    instagramUrl: data?.instagramUrl || "",
  };

  if (displayData.type === "ACTING") {
    return (
      <div className="cc-unit-info cc-unit-acting-info">
        <img
          className="cc-unit-acting-logo"
          src={ActingLogo}
          alt="권한대행 로고"
        />

        <span className="cc-unit-acting-message">
          현재 해당 단과대 학생회는 권한대행 체제입니다.
        </span>
      </div>
    );
  }

  if (displayData.type === "EMERGENCY_COMMITTEE") {
    return (
      <div className="cc-unit-info">
        <div className="cc-unit-logo-circle">
          <img
            className="cc-unit-logoImg"
            src={EmergencyLogo}
            alt="비상대책위원회 로고"
          />
        </div>

        <h2 className="cc-unit-council-title">'{displayData.name}'</h2>

        <span className="cc-unit-emergency-slogan">
          공백 없는 학생자치를 위해,
          <br />
          현재 비상대책위원회 체제로 운영 중입니다.
        </span>

        {displayData.officeLocation && (
          <div className="cc-unit-location">
            <img className="cc-unit-lctImg" src={MapPin} alt="위치 아이콘" />
            <span>{displayData.officeLocation}</span>
          </div>
        )}

        <div className="cc-unit-sns">
          {displayData.kakaoUrl && (
            <a
              className="cc-unit-sns-box"
              href={displayData.kakaoUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={Kakao} alt="카카오" />
            </a>
          )}

          {displayData.instagramUrl && (
            <a
              className="cc-unit-sns-box"
              href={displayData.instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={Insta} alt="인스타" />
            </a>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="cc-unit-info">
      {displayData.profileImg && (
        <div className="cc-unit-logo-circle">
          <img
            className="cc-unit-logoImg"
            src={displayData.profileImg}
            alt={`${displayData.name} 로고`}
          />
        </div>
      )}

      <h2 className="cc-unit-council-title">'{displayData.name}'</h2>

      {displayData.slogan && (
        <span className="cc-unit-slogan">"{displayData.slogan}"</span>
      )}

      {displayData.officeLocation && (
        <div className="cc-unit-location">
          <img className="cc-unit-lctImg" src={MapPin} alt="위치 아이콘" />
          <span>{displayData.officeLocation}</span>
        </div>
      )}

      <div className="cc-unit-sns">
        {displayData.kakaoUrl && (
          <a
            className="cc-unit-sns-box"
            href={displayData.kakaoUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={Kakao} alt="카카오" />
          </a>
        )}

        {displayData.instagramUrl && (
          <a
            className="cc-unit-sns-box"
            href={displayData.instagramUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={Insta} alt="인스타" />
          </a>
        )}
      </div>
    </div>
  );
}